<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Thông tin kỳ kiểm tra</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <ExamFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <v-card outlined class="elevation-0">
      <StudentExamTable :studentExams="studentExams" />
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ExamFilter from '../../../modules/exam/student/ExamFilter.vue'
import StudentExamTable from '../../../modules/exam/student/StudentExamTable.vue'
import { get } from 'lodash'

export default {
  components: {
    ExamFilter,
    StudentExamTable
  },
  data() {
    return {
      studentExams: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  async created() {
    this.$loading.active = true
    await this.getStudentExams()
    this.$loading.active = false
  },
  methods: {
    ...mapActions('studentExam', ['fetchStudentExams']),
    async getStudentExams(query) {
      this.$loading.active = true
      const student = get(this.user, 'student._id', null)
      const studentExams = await this.fetchStudentExams({ ...query, student: student })
      this.studentExams = studentExams
      this.$loading.active = false
    },
    async onFilterChanged(params) {
      await this.getStudentExams(params)
    }
  }
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
